import { $emit as l } from "../utils/gogocodeTransfer.js";
import { ElDatePicker as i } from "element-plus";
import { resolveComponent as o, openBlock as d, createElementBlock as u, createVNode as s, mergeProps as p } from "vue";
import { _ as m } from "../_plugin-vue_export-helper-dad06003.js";
const h = {
  name: "rDatePicker",
  props: {
    /**
     * 目前支持type为daterange和date两种
     */
    type: {
      type: String,
      default: "daterange"
    },
    /**
     * 范围选择时开始日期的占位内容
     */
    startPlaceholder: {
      type: String,
      default: ""
    },
    /**
     * 范围选择时结束日期的占位内容
     */
    endPlaceholder: {
      type: String,
      default: ""
    },
    /**
     * 非范围选择时的占位内容
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * 绑定值的格式。不指定则绑定值timestamp
     */
    valueFormat: {
      type: String,
      default: "timestamp"
    },
    /**
     * 绑定值
     */
    value: {}
  },
  emits: [
    {
      /**
       * 时间变化时触发的事件
       * @param {} value
       */
      changeDate: (e) => null
    },
    "changeDate",
    "update:value"
  ],
  components: {
    DatePicker: i
  },
  methods: {
    changeDate(e) {
      l(this, "changeDate", e), l(this, "update:value", e);
    }
  },
  computed: {
    hasValueStyle() {
      return this.value instanceof Array && this.value[0] === void 0 && this.value[1] === void 0 ? "" : this.value ? "is-value" : "";
    }
  },
  data() {
    return {
      icon: ""
    };
  }
}, f = { class: "r-date-picker" };
function v(e, k, t, g, n, r) {
  const c = o("DatePicker", !0);
  return d(), u("div", f, [
    s(c, p(e.$attrs, {
      ref: "datePicker",
      value: t.value,
      type: t.type,
      "start-placeholder": t.startPlaceholder || e.$t("bmui-date-picker.startPlaceHolder"),
      "end-placeholder": t.endPlaceholder || e.$t("bmui-date-picker.endPlaceHolder"),
      placeholder: t.placeholder || e.$t("bmui-date-picker.placeholder"),
      class: r.hasValueStyle,
      size: "mini",
      onInput: r.changeDate,
      "prefix-icon": n.icon,
      "range-separator": "",
      "value-format": t.valueFormat,
      "popper-class": "r-picker-panel"
    }), null, 16, ["value", "type", "start-placeholder", "end-placeholder", "placeholder", "class", "onInput", "prefix-icon", "value-format"])
  ]);
}
const a = /* @__PURE__ */ m(h, [["render", v], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/date-picker/date-picker.vue"]]);
a.install = function(e) {
  e.component(a.name, a);
};
export {
  a as default
};
